import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Chat do backoffice (Sprint 11.4). A resposta ao que a equipe envia já volta no turbo_stream do
// próprio request (processamento síncrono); o que falta é a mensagem proativa, criada fora de
// qualquer request por Messaging::DispatchJob. Em vez de ActionCable (cable.yml usa `async` em
// development e o worker roda em outro processo), buscamos o que chegou depois da última
// mensagem conhecida.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 10000 } }

  connect() {
    this._timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this._timer)
    this._timer = null
  }

  async poll() {
    if (document.visibilityState !== "visible") return

    const field = document.getElementById("chat-last-message-id")
    const after = field ? field.value : "0"

    const response = await fetch(`${this.urlValue}?after=${encodeURIComponent(after)}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin"
    })
    if (response.status !== 200) return

    const html = await response.text()
    if (html.trim().length > 0) Turbo.renderStreamMessage(html)
  }
}
